module.exports = __webpack_public_path__ + "img/pain-point-3.b3fa455b.svg";